import { useMemo, useState } from "react";

export const DEFAULT_ROWS_PER_PAGE = 50;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [25, 50, 100, 250];

// Slice an in-memory list into pages and reset when the filter key changes.
export const useClientPagination = (
  rows = [],
  resetKey = "",
  defaultRowsPerPage = DEFAULT_ROWS_PER_PAGE
) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [appliedResetKey, setAppliedResetKey] = useState(resetKey);
  const safeRows = Array.isArray(rows) ? rows : [];
  const maxPage = Math.max(0, Math.ceil(safeRows.length / rowsPerPage) - 1);

  if (resetKey !== appliedResetKey) {
    setAppliedResetKey(resetKey);
    setPage(0);
  } else if (page > maxPage) {
    setPage(maxPage);
  }

  const currentPage = resetKey !== appliedResetKey ? 0 : Math.min(page, maxPage);

  const pagedRows = useMemo(() => {
    const start = currentPage * rowsPerPage;
    return safeRows.slice(start, start + rowsPerPage);
  }, [safeRows, currentPage, rowsPerPage]);

  // useCallback is not needed. These only call setState, and callers do not depend on a stable identity.
  const handlePageChange = (_event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    const nextRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(Number.isNaN(nextRowsPerPage) ? defaultRowsPerPage : nextRowsPerPage);
    setPage(0);
  };

  return {
    page: currentPage,
    rowsPerPage,
    pagedRows,
    count: safeRows.length,
    handlePageChange,
    handleRowsPerPageChange,
  };
};
